import i18n from '../../i18n';
import { generatePreview, getKey, getPriceInCurrency } from '../../utils';

const DOMAIN = 'https://bikesbooking.com';

const getBikeTypeName = (bike, bikeTypes, lang) => {
  const bikeType = bikeTypes.find(({ id }) => id === bike.bikeType);
  return bikeType ? i18n.t(bikeType.name, { ns: 'bikeTypes', lng: lang }) : '';
};

const getBikeImage = (bike) => {
  if (!bike.photos || !bike.photos.length) {
    return null;
  }

  return generatePreview(bike.photos[0].image, 0, 400);
};

const getBikePrice = (bike) => {
  const averagePrice = getPriceInCurrency(bike.averagePrice, 'EUR');
  return averagePrice ? Math.floor(averagePrice / 100) : null;
};

const getPageBikeTypeName = (page, lang) => {
  if (!page || !page.bikeType) {
    return '';
  }

  return i18n.t(page.bikeType.name, { ns: 'bikeTypes', lng: lang });
};

export const ldJson = ({
  page,
  lang,
  city,
  bikes,
  bikeTypes
}) => {
  const bikeTypeName = getPageBikeTypeName(page, lang);

  const offers = bikes.map((bike) => {
    const image = bike ? getBikeImage(bike) : null;

    return {
      '@type': 'Offer',
      name: bike.name,
      price: getBikePrice(bike),
      priceCurrency: 'EUR',
      image: image ? `${DOMAIN}${image}` : null,
      category: getBikeTypeName(bike, bikeTypes, lang)
    };
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: city ? `${bikeTypeName} rental in ${city.name}` : null,
    description: page ? getKey(page, 'seoDescription') : null,
    image: page && page.headerImage ? page.headerImage : null,
    url: page ? `${DOMAIN}/${lang}/${page.url}/` : null,
    '@id': page ? `${DOMAIN}/${lang}/${page.url}/#product` : null,
    sameAs: [
      'https://www.facebook.com/bikesbooking',
      'https://twitter.com/BikesBooking',
      'https://www.instagram.com/bikesbookingcom/'
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: page ? page.ratingValue : null,
      bestRating: '5',
      worstRating: '3',
      ratingCount: page ? page.ratingCount : null,
      reviewCount: page ? page.reviewCount : null
    },
    offers
  };
};



// WEBPACK FOOTER //
// ./src/components/StaticCityPage/ldJson.js